module.exports = __webpack_public_path__ + "img/receiptWithTax.1bb1011f.svg";